interface Props {
  children?: React.ReactNode;
  text?: string;
}

export const Label: React.FC<Props> = ({ children = undefined, text = '' }) => {
  return <label>{children || text}</label>;
};
